<!--
 * @Author: your name
 * @Date: 2021-08-26 09:49:59
 * @LastEditTime: 2021-11-17 11:03:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/pages/courseDetail/courseComponents/goodcourse.vue
-->
<template>
  <div class="goodcourseWarrp">
    <div v-for="(item, index) in goodcourseList" :key="index">
      <CombinationCard
        @click.native="needBack(item)"
        v-if="item.setType === 1"
        :item="item"
        :key="index"
      />
      <HotCourseCard v-else @click.native="needBack(item)" class="card" :item="item" :key="index" />
    </div>

  </div>
</template>
<script>
import { mapState } from 'vuex';
import CombinationCard from '@/components/combinationCard/combinationCard.vue';
import { gioPlatform } from '@/utils/tools';
import HotCourseCard from '../../../components/hotCourseCard/hotCourseCard.vue';

export default {
  components: { HotCourseCard, CombinationCard },
  data() {
    return {};
  },
  props: {
    goodcourseList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState(['courseBaseData']),
  },
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    needBack(item) {
      sessionStorage.setItem('back', true);
      this.gioEvent(item);
    },
    gioEvent(item) {
      const { setType } = item;
      const courseName = item.name;
      const BigName = this.courseBaseData.name;
      // 点击广告
      // eslint-disable-next-line
        gio('track', 'adClick_event', {
        adPosition_var: '课程推荐', // 广告位置
        pageName_var: '课程详情', // 页面名称
        courseName_var: BigName,
        adSequence_var: null, // 广告序号
        adId_var: null, // 广告ID
        adName_var: courseName, // 广告名称
        linesBusiness_var: '考研', // 业务线
        jumpType_var: setType === 1 ? '套餐' : '产品', // 跳转类型
        platform_var: gioPlatform(),
      });
    },
  },
};
</script>
<style scoped lang="scss">
.goodcourseWarrp {
  width: 678px;
  margin: 0 auto;
  padding-top: 36px;
  ::v-deep .dkillItem {
    box-shadow: 0 16px 14px 0 rgba(0, 0, 0, 0.03);
  }
}
</style>
